import { Contracts } from "../contracts/contracts";
import { SibBaseObject } from "../BaseObject/SibBaseObject";
import { ContractHoardings } from "../contracts/contract-hoarding";
import { AbstractItem } from "./abstract-hoarding";

export class HoardingGroup extends AbstractItem {
    hoardings: ContractHoardings[]= [];
}
